import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { updateFormInstance } from 'actions/templates';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Spinner } from 'UI';
import { Field } from 'UI/Inputs';
import { Button, translate } from '@haldor/ui';
var FormInstance = /*#__PURE__*/function (_Component) {
  function FormInstance() {
    var _this;
    _classCallCheck(this, FormInstance);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormInstance, [].concat(args));
    _defineProperty(_this, "submit", function (values) {
      return new Promise(function (resolve) {
        var fieldResults = [];
        var status = values.status;
        if (status == null) {
          status = 'SAVED';
        }
        Object.keys(values).map(function (key, index) {
          var _this$props$instance;
          if (key == 'status') {
            return;
          }
          var templateField = _this.props.fields.find(function (t) {
            return t.name == key;
          });
          var instanceField = (_this$props$instance = _this.props.instance) === null || _this$props$instance === void 0 ? void 0 : _this$props$instance.fieldResults.find(function (t) {
            return t.fieldName == key;
          });
          var result = {
            'fieldName': key,
            'value': values[key],
            'FieldTemplateId': templateField != null ? templateField.id : null,
            'id': instanceField != null ? instanceField.id : null
          };
          fieldResults.push(result);
        });
        var data = {
          fieldResults: fieldResults,
          status: status
        };
        if (_this.props.onSubmit != null && _this.props.instance == null) {
          _this.props.onSubmit(data).then(function () {
            resolve(1);
            if (_this.props.onAbort != null) {
              _this.props.onAbort(true);
            }
          });
        } else {
          var _data = _this.props.instance;
          _data.fieldResults = fieldResults;
          _data.status = status;
          _this.props.updateFormInstance(_data).then(function () {
            resolve(1);
            if (_this.props.onAbort != null) {
              _this.props.onAbort(true);
            }
          });
        }
      });
    });
    return _this;
  }
  _inherits(FormInstance, _Component);
  return _createClass(FormInstance, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        translate = _this$props.translate;
      if (this.props.fields == null) {
        return null;
      }
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit.bind(this)),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form form-component"
      }, this.props.fields.map(function (field, index) {
        field.disabled = _this2.props.followUp != null ? _this2.props.followUp : false;
        return /*#__PURE__*/React.createElement(Field, _extends({
          key: 'field-' + index
        }, field));
      })), this.props.fields.length > 0 && !this.props.followUp ? /*#__PURE__*/React.createElement("div", {
        className: "form-row submit spacing"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: 'SUBMITTED'
          }));
        }),
        disabled: submitting || this.props.disabled
      }, submitting ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : null, translate('Save')), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })) : null);
    }
  }]);
}(Component);
function mapStateToProps(state, ownProps) {
  var initialValues = null;
  if (ownProps.instance != null) {
    initialValues = {};
    ownProps.instance.fieldResults.forEach(function (result) {
      initialValues[result.fieldName] = result.value;
    });
  }
  return {
    initialValues: initialValues,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  updateFormInstance: updateFormInstance
})(reduxForm({
  destroyOnUnmount: true,
  enableReinitialize: true,
  pure: false
})(FormInstance));